import { Redirect, usePathname } from "expo-router";
import type { ReactNode } from "react";

import { useStaffAuth } from "../providers/StaffAuthProvider";
import { LoadingState } from "./ui";

export function CentralRouteGuard({ children }: { children: ReactNode }) {
  const auth = useStaffAuth();
  const pathname = usePathname();
  if (auth.status === "loading") {
    return <LoadingState label="Preparing Central" description="Restoring your workspace." />;
  }
  if (auth.status !== "authenticated") return <Redirect href="/signed-out" />;
  if (
    auth.identity?.access.role === "support" &&
    !pathname.replace(/\/+$/, "").endsWith("/workspace/family-access-support")
  ) {
    return <Redirect href="/workspace/family-access-support" />;
  }
  return <>{children}</>;
}
